/**
 * @fileoverview Agent definition for the plot-synopsis-extractor-chunked-v3 primitive.
 *
 * This agent summarizes a single chunk of a large document as part of a
 * map-reduce synopsis pipeline. Each chunk is processed independently,
 * then the per-chunk synopses are merged by a final pass using
 * plot-synopsis-extractor-v3 with a merge prompt.
 *
 * @category import.story.synopsis.chunked
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-synopsis-extractor-chunked-v3',
  kind: 'primitive',
  name: 'Chunked Synopsis Extractor',
  description: 'Summarizes a single chunk of a large document. Part of the map-reduce synopsis pipeline for epic-length content.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'import.story.synopsis.chunked',
    usedBy: ['use-plot-synopsis-extractor-v3.ts', 'use-long-form-import.ts'],
    relatedAgents: ['plot-synopsis-extractor-v3'],
  },
};
